import ReactReconciler from "react-reconciler";
function applyProps(domElement, props, oldProps) {
    if (oldProps === void 0) { oldProps = {}; }
    Object.keys(oldProps).forEach(function (key) {
        var oldVal = oldProps[key];
        if (key.startsWith("on") && typeof oldVal === "function") {
            var eventType = key.slice(2).toLowerCase();
            domElement.removeEventListener(eventType, oldVal);
        }
    });
    Object.keys(props).forEach(function (key) {
        var value = props[key];
        if (oldProps[key] === value)
            return;
        if (key.startsWith("on") && typeof value === "function") {
            var eventType = key.slice(2).toLowerCase();
            domElement.addEventListener(eventType, value);
            return;
        }
        if (key === "className") {
            domElement.setAttribute("class", value);
            return;
        }
        if (key === "css") {
            if (typeof value === "object") {
                var styleString = Object.entries(value)
                    .map(function (_a) {
                    var styleKey = _a[0], styleVal = _a[1];
                    var cssKey = styleKey.replace(/([A-Z])/g, "-$1").toLowerCase();
                    var cssValue = typeof styleVal === "number" ? styleVal + "px" : styleVal;
                    return cssKey + ": " + cssValue;
                })
                    .join("; ");
                domElement.setAttribute("style", styleString);
            }
            else {
                domElement.setAttribute("style", value);
            }
            return;
        }
        if (key === "children") {
            if (typeof value === "string" || typeof value === "number") {
                domElement.textContent = value + "";
            }
            return;
        }
        domElement.setAttribute(key, value);
    });
}
var hostConfig = {
    now: Date.now,
    supportsMutation: true,
    getRootHostContext: function () { return ({}); },
    getChildHostContext: function () { return ({}); },
    prepareForCommit: function () { },
    resetAfterCommit: function () { },
    shouldSetTextContent: function (type, props) {
        return typeof props.children === "string" || typeof props.children === "number";
    },
    createInstance: function (type, props, rootContainerInstance, _currentHostContext, workInProgress) {
        var domElement = document.createElement(type);
        applyProps(domElement, props);
        return domElement;
    },
    createTextInstance: function (text) { return document.createTextNode(text); },
    appendInitialChild: function (parent, child) { return parent.appendChild(child); },
    appendChild: function (parent, child) { return parent.appendChild(child); },
    appendChildToContainer: function (parent, child) { return parent.appendChild(child); },
    removeChild: function (parent, child) { return parent.removeChild(child); },
    removeChildFromContainer: function (parent, child) { return parent.removeChild(child); },
    commitTextUpdate: function (textInstance, oldText, newText) {
        textInstance.textContent = newText;
    },
    prepareUpdate: function (domElement, oldProps, newProps) { return true; },
    commitUpdate: function (domElement, updatePayload, type, oldProps, newProps) {
        applyProps(domElement, newProps, oldProps);
    },
    finalizeInitialChildren: function () { return false; },
    resetTextContent: function () { },
    getPublicInstance: function (instance) { return instance; },
    insertBefore: function (parent, child, beforeChild) {
        return parent.insertBefore(child, beforeChild);
    },
};
function traceWrap(hostConfig) {
    var wrapped = {};
    Object.keys(hostConfig).forEach(function (key) {
        var func = hostConfig[key];
        wrapped[key] =
            typeof func === "function" ? function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return func.apply(void 0, args);
            } : hostConfig[key];
    });
    return wrapped;
}
var ReactReconcilerInst = ReactReconciler(traceWrap(hostConfig));
export default {
    render: function (reactElement, domElement, callback) {
        // Create a root Container if it doesnt exist
        if (!domElement._rootContainer) {
            domElement._rootContainer = ReactReconcilerInst.createContainer(domElement, false);
        }
        // update the root Container
        return ReactReconcilerInst.updateContainer(reactElement, domElement._rootContainer, null, callback);
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/MyRenderer.ts
// module id = 80
// module chunks = 1